import api from './api';

/**
 * @param {string} id
 * @returns
 */
export default async function deleteAutomarkerTargetTemplate(id) {
    const { data } = await api.delete(`target_templates/${id}`);

    return data;
}